<template>
	<div class="group-avatar" :class="{ small: isSmall }">
		<v-badge avatar overlap color="#5B8AF7" class="text-center" :offset-y="offsetY" :offset-x="offsetX">
			<template v-slot:badge>
				<SIcon name="groups-badge" :width="size / 2" class="groups-badge" />
			</template>

			<v-avatar :size="size" :color="avatarColor">
				<SIconServices
					v-if="group.synced"
					class="integration-name"
					:name="integrationName"
					:height="syncedGroupSize"
					:width="syncedGroupSize"
					:aspect-ratio="1"
					:style="{ height: syncedGroupSize + 'px', width: syncedGroupSize + 'px', padding: syncedGroupPadding + 'px' }"
				/>
				<img v-else-if="group.avatar" :src="group.avatar" />
				<SIcon v-else-if="group.internalIcon" :name="group.internalIcon" />
				<span class="letter" :class="{ 'small-letter': size < 30 }" v-else>{{ shortenName }}</span>
			</v-avatar>
		</v-badge>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getService } from '@/store/modules/apps/getters';
import SIconServices from '@/components/SIconServices';
export default {
	name: 'AppGroupAvatar',
	components: {
		SIconServices,
	},
	props: {
		group: { type: Object },
		size: { type: Number, default: 40 },
		avatarColor: { type: String, default: '#E7E9EC' },
		syncedGroupSize: { type: Number, default: 20 },
		syncedGroupPadding: { type: Number, default: 0 },
	},
	computed: {
		...mapGetters([getService.fullPath]),
		shortenName() {
			const { name } = this.group;
			return name?.charAt(0) || name;
		},
		integrationName() {
			if (!this.group.synced || !this.group.synced.service) {
				return '';
			}
			return this[getService.fullPath](this.group.synced.service).service_slug;
		},
		isSmall() {
			return this.size <= 18;
		},
		offsetX() {
			return this.isSmall ? 18 : this.size / 2.4;
		},
		offsetY() {
			return this.isSmall ? 3 : null;
		},
	},
};
</script>

<style scoped lang="scss">
.group-avatar {
	.letter {
		font-size: 22px;
		color: #5a677d;
		font-weight: 300;
		text-transform: uppercase;
	}
	.small-letter {
		font-size: 14px;
	}
	.groups-badge {
		vertical-align: sub;
	}

	::v-deep .v-badge__wrapper {
		transform: scale(0.85) translate(21%, 14%);
	}
	&.small {
		::v-deep .v-badge__badge {
			transform: scale(0.72) translate(21%, 14%);
		}
	}
	&:not(.small) {
		::v-deep .v-badge__wrapper {
			transform: scale(0.85) translate(21%, 14%);
		}
	}
}
</style>
